import clsx from "clsx"
import React from "react"

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  sizes: string
}

export const Skeleton: React.FC<SkeletonProps> = ({ sizes, className, ...props }) => {
  return <div className={clsx("skeleton-box", sizes, className)} {...props} />
}
